import type { Process } from '@safc/configuration';
import { MaybeCensored } from 'features/units/utils/MaybeCensored.js';

import type { CensoredUnitResponse } from '../../types/index.js';

export type ProcessResponse = {
  processes?: Process[];
};

export const mapProcess = (process: Process, ownerId: string) => ({
  status: process.computed.status,
  transactionType: process.computed.transactionType,
  ownerId,
  initiator: process.actor.userName,
  transactionDate: process.createdAt,
  count: process.volume,
  approvalRequestId: undefined,
  processType: process.type,
  ...process,
  maybeCensoredUnit: MaybeCensored.wrap(process.unit) as unknown as CensoredUnitResponse,
});

export type HoldingsProcess = ReturnType<typeof mapProcess>;
